import axios from 'axios'
import extend from 'extend'

import StringTableService from '../string-table'
import {
    init as initMockResponse,
    handleMockResponse,
    USE_MOCK_RESPONSE
} from './mock-responses'

export const HttpMethod = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete'
}

const handledEndpoints = [
    {
        endpoint: /(.*)\/offers$/,
        methods: [HttpMethod.GET, HttpMethod.POST, HttpMethod.DELETE, HttpMethod.PUT]
    },
    {
        endpoint: /(.*)\/offers\/metadata/,
        methods: [HttpMethod.GET]
    },
    {
        endpoint: /(.*)\/offers\//,
        methods: [HttpMethod.GET, HttpMethod.POST, HttpMethod.PUT, HttpMethod.DELETE]
    },
    {
        endpoint: /(.*)\/summary-reports\/.*\/summaries/,
        methods: [HttpMethod.GET]
    }
]

export default class ServiceCore {
    static defaultRequestOptions = {
        method: HttpMethod.GET,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        validateStatus: ServiceCore.validateStatus
    }

    static init(history, doLogout) {

        const attachErrorCallback = (error) => {
            error.callback = () => {
                // lack of response object usually means CORS error due to amazon gateway auth error, assume 401
                const status = error.response ? error.response.status : 401
                if (status === 401) {
                    doLogout()
                    return true
                }

                const pageUrl = error.response.config.url
                const showNotification = handledEndpoints.some(handledEndpoint => {
                    return pageUrl.match(handledEndpoint.endpoint) &&
                        handledEndpoint.methods.includes(error.response.config.method)
                })

                if (showNotification) {
                    return false
                }

                const forbiddenRoute = StringTableService.getString(StringTableService.keys.forbiddenRoute)
                const serverErrorRoute = StringTableService.getString(StringTableService.keys.serverErrorRoute)

                switch (status) {
                    case 403:
                        history.push(forbiddenRoute)
                        break

                    default:
                    case 500:
                        history.push(serverErrorRoute)
                        break
                }

                return true
            }
        }
        
        // register response interceptor to handle error codes not accepted by validateStatus
        axios.interceptors.response.use(
            (response) => { 
                if(response.data.hasOwnProperty("policy") && response.data.hasOwnProperty("userInfo") && response.data.hasOwnProperty("workspace") ){
                    let wp = sessionStorage.getItem("workspace");
                    if(response.data.workspace.showMessage!='none' && wp=='{}'){
                        document.getElementById("app").style.display = 'none';
                        window.alertUserNavigation(response);                         
                    }
                }
                return response ;
            },
            (error) => {
                attachErrorCallback(error)

                return Promise.reject(error)
            }
        )

        if (USE_MOCK_RESPONSE) {
            initMockResponse(attachErrorCallback)
        }
    }

    static request(options) {
        const requestOptions = ServiceCore.buildOptions(options)

        return handleMockResponse(requestOptions)
            .then(response => {
                if (response) {
                    return response
                }

                return axios.request(requestOptions)
            })
    }

    static validateStatus(status) {
        //TODO OSP-3483 remove OR condition for 409, will be replaced with more robust solution.
        return (200 <= status && 300 > status) || 409 === status
    }

    static buildOptions(options) {
        return extend(true, {}, ServiceCore.defaultRequestOptions, options)
    }
}



// WEBPACK FOOTER //
// src/services/core/index.js